module.exports = __webpack_public_path__ + "static/media/booking-submitted.faf33990.svg";